import _wpapix from './wpapix'
import store from '@/store'
import Swal from 'sweetalert2'
import { Logger } from '@/lib/logger'

export const mkApiRequest = ( type, arg ) => {
  return ( to, from, next ) => {
    Logger.debug( 'this', 'lib/mkApiRequest()', this )()
    Logger.debug( 'context', 'lib/mkApiRequest()', { to, from, next })()
    _wpapix.then( wpapix => {
      var object = new wpapix[ type ]( arg ? arg( to ) : to.params )
      object.fetch({
        success: ( model, result, options ) => {
          Logger.debug(
            'got',
            'lib/mkApiRequest()',
            {
              object,
              result: JSON.parse( JSON.stringify( result ))
            }
          )()
          if ( result.admin_redirect ) {
            next({ path: result.admin_redirect })
          } else if ( result.members_only && !store.state.user.membership ) {
            if ( result.preview ) {
              next({ path: `/preview/${ result.preview }` })
            } else if ( result.redirect ) {
              next({ path: result.redirect })
            } else {
              next({ path: '/shop/membership', then: to.path })
            }
          }
          store.dispatch( 'setPostData', result )
          next()
        },
        error: ( model, result, options ) => {
          // Swal.fire(
          //   'Sorry! We couldn\'t get you that page.<br/>Please try again later'
          // )
          next( result.redirect
                ? { path: result.redirect }
                : { name: 'not-found', query: { ...to.query, q: to.path }})
        }
      })
      // TODO: handle specific errors
    })
  }
}
export const toPreviewRelease = mkApiRequest( 'Preview', to => {
  return { path: `${ to.params.program }/${ to.params.release }` }
})
export const toPreview = mkApiRequest( 'Preview' )
export const toPath = mkApiRequest( 'Path' )
export const toAdminPath = mkApiRequest( 'AdminPath' )
export const toRelease = mkApiRequest( 'Release' )

export default {
  mkApiRequest,
  toPreviewRelease,
  toPreview,
  toPath,
  toAdminPath,
  toRelease,
}
